import React from 'react'
import styled from 'react-emotion'
import { Link } from 'gatsby'

import { Container } from './Bootstrap'

import { colours } from '../theme'

const Wrapper = styled('header')`
	background-color: ${colours.secondary};
	left: 0;
	position: fixed;
	top: 0;
	width: 100%;
	z-index: 999;
`

const Nav = styled('nav')`
	display: flex;
	justify-content: space-between;
	&>a {
		background-colour: ${colours.secondary};
		color: #fff;
		display: block;
		flex: 1;
		font-size: 1.111rem;
		padding: 0.5rem 0;
		text-align: center;
		transition: background 250ms linear;
		&:hover {
			background-color: ${colours.primary};
		}
	}
`

const Header = () => (
	<Wrapper>
		<Container>
			<Nav>
				<Link to="/">Overview</Link>
				<Link to="/results"><span className="d-none d-md-inline">Survey </span>Results</Link>
				<Link to="/swot"><span className="d-none d-md-inline">SWOT </span>Analysis</Link>
				<Link to="/goals"><span className="d-none d-md-inline">Main </span>Goals<span className="d-none d-md-inline"> of CILT</span></Link>
			</Nav>
		</Container>
	</Wrapper>
)

export default Header
